<span class="text-14px" *ngIf="buttonText">{{ buttonText }}</span>
<ng-content *ngIf="!buttonText"></ng-content>
